module.exports = __webpack_public_path__ + "static/media/reason_for_appointment.111ab912.svg";